import defaultCartBackground from './assets/background.jpg';
import easyAppQrCode from './assets/easy-app-qr-code.svg';
import defaultEnterPlu from './assets/enterPlu.png';
import defaultLogoBlack from './assets/logoBlack.svg';
import defaultLogoColor from './assets/logoColor.svg';
import defaultLogoCompany from './assets/logoCompany.svg';
import logoPayback from './assets/logoPayback.png';
import defaultLogoWhite from './assets/logoWhite.svg';
import { resolveBrandPalette } from './resolveBrand';
import { Brand } from '@whiz-cart/node-shared/models/brand/brand';

export const defaultBrand = {
    _id: 'easyshopper',
    palette: resolveBrandPalette({
        primary: {
            main: '#84bd00',
            light: '#bcd47d',
            dark: '#60742f',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#0d99ff',
            light: '#70c3ff',
            dark: '#00497e',
            contrastText: '#ffffff',
        },
        discount: {
            main: '#d30c2a',
            contrastText: '#ffffff',
        },
        free: {
            main: '#84bd00',
            contrastText: '#ffffff',
        },
        cartBackground: {
            main: '#333333',
            light: '#d9d9d9',
            dark: '#d9d9d9',
            contrastText: '#ffffff',
        },
        navigationBackground: {
            main: '#333333',
            light: '#646464',
            dark: '#333333',
            contrastText: '#ffffff',
        },
        disruptor: {
            main: '#fdd764',
            contrastText: '#ffffff',
        },
    }),
    images: {
        logoBlack: defaultLogoBlack,
        logoWhite: defaultLogoWhite,
        logoColor: defaultLogoColor,
        logoCompany: defaultLogoCompany,
        cartBackground: defaultCartBackground,
        enterPlu: defaultEnterPlu,
    },
    icons: {},
    customIcons: {},
    customerIds: [
        {
            id: 'easy-app',
            name: 'EASY App',
            image: easyAppQrCode,
            logoImage: null,
            color: {
                main: '#003EB0',
                contrastText: '#ffffff',
            },
            pointsText: null,
            showOnWelcomeScreen: true,
            showAppStores: true,
            useImageAsLogoImage: true,
            type: 'mobileApp',
            styleId: 'easy-app',
        },
        {
            id: 'Payback',
            name: 'PAYBACK',
            image: logoPayback,
            logoImage: null,
            color: {
                main: '#003EB0',
                contrastText: '#ffffff',
            },
            pointsText: '+{points}° P',
            showOnWelcomeScreen: true,
            showAppStores: true,
            useImageAsLogoImage: true,
            type: 'card',
            styleId: 'payback',
        },
    ],
    borderRadius: 15,
    cartBrand: 'EASY Shopper',
    cartBrandShort: 'EASY',
    storeBrand: 'EDEKA',
    loyaltyCard: 'PAYBACK',
    headerDisplayTotal: false,
    headerUsePrimaryColor: false,
    priceLayoutAlt: false,
    promotionsLayoutAlt: false,
    highlightAddToBasket: false,
    cartUiTutorialSlides: [],
} as const satisfies Brand;
